import { ServiceManager, ServiceBusController } from '@estee/elc-service';
import { events, on, queryProvider, serviceQueries } from '@estee/elc-service-bus';
import { ServiceBusControllerBody } from '@estee/elc-service/typings/Service/ServiceManager/ServiceManager';

const queries = [[serviceQueries.GET_APPT_BOOKING_COUNTERS, 'getApptBookingCounters']];

const onEvents = [
    [events.BOOK_VIRTUAL_APPOINTMENT_CLICKED, 'onStoreBookVirtualAppointment'],
    [events.REVIEWS_PAGINATION_CLICKED, 'onReviewsPageViewed'],
    [events.REVIEWS_RATING_CLICKED, 'onReviewsRatingClicked'],
    [events.REVIEWS_SEARCH_CLICKED, 'onReviewsSearchClicked'],
    [events.REVIEWS_SORT_BY_CHANGED, 'onReviewsSortByChanged']
];

export class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                queries.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
                onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
            }
        }, 50);
    };
}

export const serviceBusBaseClass = new ServiceBus() as ServiceBusControllerBody;
